export * from './magenty.routes';
